import { CheckoutContext } from '@/context/CheckoutContext';
import { CheckoutRedirectOrderStatus } from '@/constants/checkoutRedirectOrderStatus';
import { buildRedirectLink } from '@/utils/redirect';
import { useContext, useMemo } from 'react';

export function useRedirectLink(orderStatus: CheckoutRedirectOrderStatus = CheckoutRedirectOrderStatus.SUCCESS) {
  const context = useContext(CheckoutContext);
  const redirectLink = context.redirectLink;
  const orderData = context.successScreen?.orderData;
  const orderId = context.redirectPayment?.orderId;

  const fullyRedirectLink = useMemo(() => {
    if (redirectLink && orderData && orderId) {
      return buildRedirectLink(redirectLink, orderData, orderId, orderStatus);
    }
    return null;
  }, [redirectLink, orderData, orderId, orderStatus]);

  return { fullyRedirectLink };
}
